import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUser } from '../core/models/currentUser.model';
import { ajaxCall } from '../core/services/ajax-call.service';

@Component({
  selector: 'app-landing-root',
  templateUrl: './landing-root.component.html',
  styles: [
  ]
})
export class LandingRootComponent implements OnInit {

  constructor(private ajax: ajaxCall,
    private router: Router) { }

  ngOnInit(): void {
    this.ajax.MakeCall<CurrentUser>('/User/Current').then(data => {
      if (!data.userId) {
        this.router.navigateByUrl('/login?returnUrl=' + window.location.pathname);
        return;
      } else if (!data.isPDxAdmin) {
        window.location.href = window.location.origin + '/customer';
        return;
      }

      //this.router.navigateByUrl('/manage');
    });
  }

}
